<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="6">
                <h1 class="subtitle-1 grey--text mb-4">Raport necesar numerar</h1>
            </v-col>
            <v-col cols="12" sm="6" class="text-right">
                <v-btn color="success" 
                    @click="getNeededMoneyAsXls"
                    :loading="downloadBtnLoading"
                >Decarcă fisier Excel <v-icon right dark>mdi-microsoft-excel</v-icon></v-btn> 
            </v-col>
        </v-row>        
        <v-row align="center">
            <v-col>
                <v-card>
                    <v-card-title>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        class="elevation-1"
                        :loading="tableLoading"
                        :text-loading="tableLoadingText"
                        :search="search"
                        :footer-props="{
                            'items-per-page-options': [10, 20, 30, 40, 50]
                        }"
                        :items-per-page="20"
                    ></v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

export default {

    data: () => {
        return {
            search: '',
            tableLoading: true,
            tableLoadingText: "Se încarcă... Te rog așteaptă",
            rowsPerPageItems: [10, 20, 30, 40],
            pagination: {
                rowsPerPage: 20
            },
            downloadBtnLoading: false,

        }
    },
    computed: {
        headers(){
            return this.$store.getters['raportNecesarNumerar/getHeaders'];
        },
        items(){
            return this.$store.getters['raportNecesarNumerar/getItems'];
        },
    },
    created() {
        this.updateData();
    },
    methods: {
        updateData(){
            
            this.tableLoading = true;
            this.$store.dispatch('raportNecesarNumerar/getNeededMoney')
            .then(()=>{
                this.tableLoading = false;
            });
        },
        updateValues(){
            this.updateData();
        },
        getNeededMoneyAsXls(){
            this.downloadBtnLoading = true;
            this.$store.dispatch('raportNecesarNumerar/getNeededMoneyAsXls')
                    .then(() => {
                        this.downloadBtnLoading = false;
                    })
                    .catch((error)=>{
                        console.log(error);
                        this.downloadBtnLoading = false;
                    }); 
        }

    },
}
</script>

<style>
.v-data-table {
    max-width: 100%
}
.reportrange-text {
    border: none !important; 
 
}
.vue-daterange-picker {
    display: block !important;
    width: 100% !important;
}
</style>